 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"81ea162","1":"89ac490","3":"27436b3","4":"2a9307e","5":"7c547e7","6":"4235fec","7":"06098e3","8":"372cf2f","9":"35d9881","10":"f294c7b","11":"a9028ab","12":"0e25cc8","13":"bee10a3","14":"01988da","15":"e8a66c4","16":"c728eae","17":"f23b502","18":"bdb9111","19":"3a2e081","20":"9abd70d","21":"e556d51","22":"66038a8","23":"8ce2ada","24":"eab748c","25":"33d1017","26":"c54301e","27":"0f3e269","28":"3b2f5b3","29":"ec2869b","30":"c93abc1","31":"256672b","32":"323ba90","33":"f505519","34":"fdaecbf","35":"3026c56","36":"5bdd50c","37":"21b3e44","38":"a6603ef","39":"0a8b131","40":"a8e4697","41":"e7a56b6","42":"3a20535","43":"12a4639","44":"7789fee","45":"be9f12b","46":"fd54e0b","47":"1e7ead8","48":"672f032","49":"cfa753f","50":"32142a5","51":"cc05ebe","52":"ec8a546","53":"71c7c4d","54":"5d9a190","55":"5648b03","56":"b690334","57":"14b6abb","58":"56a5795","59":"1ee312b","60":"190cbac","61":"2d7a4ba","62":"fb8a8b1","63":"6fb2512","64":"479ad5f","65":"cee6b3e","66":"f686834","67":"d247016","68":"3e00e93","69":"0d72367","70":"d4541fa","71":"72ea818","72":"d1561bd","73":"1441e2e","74":"b1ef5b7","75":"98db487","76":"1b8dcc4","77":"76dbe41","78":"9dd0a04","79":"3a8a611","80":"6e5eeee","81":"d0136df","82":"184b23b","83":"62ea721","84":"619dd6e","85":"bd618d2","86":"1e86d87","87":"ee811a1","88":"d409bc7","89":"a2adf7b","90":"c666216","91":"6728c76","92":"cb284fa","93":"7f5e961","94":"8fdb9ba","95":"185a11c","96":"c9d4f37","97":"76453fa","98":"02720f4","99":"0b07736","100":"dbec758","101":"f0c94c4","102":"5f9ec5c","103":"6c4af4b","104":"417fc17","105":"8ea2b10","106":"6f6783c","107":"ad2c71e","108":"3557625","109":"f22f338","110":"9be196e","111":"86e28ab","112":"0b66b55","113":"fa99834","114":"c08ff5a","115":"c66de8a","116":"f7658e4","117":"0b547ed","118":"f3dd082","119":"aa9b0b1","120":"c92e4f2","121":"3f09793","122":"c0629f5","123":"e858142","124":"717ec22","125":"45539a0","126":"1b9b7c9","127":"82100bf","128":"683d773","129":"f48fbfc","130":"105de5e","131":"281840d","132":"68a98ae","133":"8a89bdb","134":"e263552","135":"516960e","136":"fe48aaf","137":"200ddd4","138":"1a0c7b9","139":"a35baae","140":"8158e97","141":"1e9ae97","142":"12e2338","143":"4a81e36","144":"289aa38","145":"303856d","146":"68c2a9c","147":"6c4480e","148":"aedee1d","149":"13c73ce","150":"ab2eec6","151":"a7ad503","152":"5a1f9e4","153":"ee7123d","154":"142bbfa","155":"0d3ad37","156":"d4b079d","157":"d2a6fa6","158":"70b04f6","159":"061a101","160":"b0226d0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var cssChunks = {"28":1,"39":1,"40":1,"41":1,"42":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"31d6cfe","1":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","15":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"5815203","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"31d6cfe","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"5b2b5b0","40":"95678cc","41":"4594b91","42":"2ea17b4","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"31d6cfe","1":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","15":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"5815203","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"31d6cfe","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"5b2b5b0","40":"95678cc","41":"4594b91","42":"2ea17b4","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-static.ecosia.org/web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 231);
